import { QueryKey } from 'enums'
import type { TableSorter } from 'hooks'

// As an example for future default sorting
export const defaultSortParams: Partial<Record<QueryKey, TableSorter[] | undefined>> = {
  // [QueryKey.GetLocationCodes]: [{ field: 'code', order: 'ascend' }],
}
